import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DurationTextPipe } from './duration-text.pipe';

@NgModule({
  exports: [DurationTextPipe],
  imports: [CommonModule, DurationTextPipe],
})
export class DurationModule {}
